import { fetchWithCors, getContentDispositionFileName } from '../network'

export class Downloader {
  static async getFromFetch(url: string, filename?: string) {
    const response = await fetchWithCors(url)
    const name =
      filename ||
      (getContentDispositionFileName(
        response.headers.get('content-disposition')
      ) as string)
    Downloader.getFromData(
      await response.blob(),
      name,
      response.headers.get('content-type') as string
    )
  }

  static getFromData(data: Blob, filename?: string, contentType?: string) {
    const blob = new Blob([data], { type: contentType })
    const objectURL = URL.createObjectURL(blob)
    Downloader.getFromBlobUrl(objectURL, filename)
  }

  static getFromBlobUrl(url: string, filename?: string) {
    const name = (filename || url.split('/').pop()) as string
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download', name)
    a.addEventListener('click', e => e.stopPropagation())
    a.click()
  }
}
